<template>
  <div class="content-item">
    <a-row align="middle">
      <a-col>
        <div class="upload-wrapper">
          <a-row :gutter="[16, 16]">
            <a-col>
              <span>{{ progress }}%</span>
            </a-col>
          </a-row>
          <a-row :gutter="[16, 16]">
            <a-col>
              <span>Uploading...</span>
            </a-col>
          </a-row>
        </div>
      </a-col>
    </a-row>
    <p class="text-warn">Do not leave this page or you will need to start over.</p>
  </div>
</template>

<script>
import Uploader from '@/services/UploadService';

export default {
  props: {
    videoFile: {
      type: File,
    },
  },
  data() {
    return {
      progress: 0,
    };
  },
  mounted() {
    this.startUpload();
  },
  methods: {
    startUpload() {
      new Uploader()
        .uploadVideoFile(this.videoFile, percent => (this.progress = percent))
        .then(data => {
          this.$emit('onComplete', data.Location);
        })
        .catch(err => {
          this.$emit('onFail', err.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-wrapper {
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
